export default "__VITE_ASSET__$7uVP2dr__"